import { useRoutes } from "react-router-dom"
import ProtectedRoutes from "./ProtectedRoutes"
import PublicRoutes from "./PublicRoutes"

export const AppRoutes = ()=>{
    return useRoutes([PublicRoutes,ProtectedRoutes])
}